import styled from "styled-components";

import {
    colors
}

from './../../../components/common/element/elements.js';

export const Styles=styled.div`

/* Course Category */
.course-category {
    // border : 1px solid ${colors.border1};
    // padding: 15px 20px 20px;
    border-radius: 5px;
    margin-bottom: 2px;

    .list-items {
        li {
            display: flex; 
            align-items: center; 
            padding: 10px 12px; 
            border: 1px solid #ccc;
            font-size: 16px; 
            border-radius: 20px;
            white-space: nowrap;
            background: rgb(249, 176, 42) ;
            color:white ;
        }
    }
    
   
    
    



    h5 {
        color : $ {
            colors.black1
        };
        text-decoration: underline;
        font-weight : 600;
        position : relative;
        margin: 25px 0;

        &:before {
            position: absolute;
            content: "";

            background : $ {
                colors.green
            }

            ;
            width : 50px;
            height: 2px;
            bottom : 0;
            left : 0;
        }

        @media(max-width: 575px) {
            font-size: 17px;
        }
    }

    ul.category-item {
        li.check-btn {
            border-top : 1px dashed $ {
                colors.border3
            };

            padding: 10px 0;

            &:last-child {
                border-bottom : 1px dashed $ {
                    colors.border3
                }

                ;
            }

            label {
                font-size: 14px;

                color: $ {
                    colors.text3
                }

                ;
                display: block;
                margin-bottom : 4px;
                cursor: pointer;

                input[type=checkbox] {
                    border : 2px solid $ {
                        colors.border3
                    }

                    ;
                    appearance: none;
                    width: 20px;
                    height: 20px;
                    cursor: pointer;
                    margin-right: 6px;
                    position: relative;
                    top: 4px;

                    &:focus {
                        outline: none;
                    }

                    &:checked {
                        background-color: $ {
                            colors.green
                        }

                        ;

                        background: $ {
                            colors.green
                        }

                        url("data:image/gif;base64,R0lGODlhCwAKAIABAP////3cnSH5BAEKAAEALAAAAAALAAoAAAIUjH+AC73WHIsw0UCjglraO20PNhYAOw==") 2px 2px no-repeat;

                        border-color : $ {
                            colors.green
                        }

                        ;
                    }
                }

                span {
                    float: right;
                    font-size: 12px;

                    color: $ {
                        colors.text2
                    }

                    ;
                    line-height: 27px;
                }
            }
        }

    }

    @media(max-width: 1199px) {
        padding: 12px 15px 15px;
    }
}

select {
    width: 100%;
    height: 48px;
    background-color:rgba(252, 231, 187, 0.38);
    font-size: 14px;
    padding: 10px 20px;
    border-radius: 10px;
    box-shadow: 0px 0px 4px lightgray;
    cursor: pointer;

    border : 2px solid $ {
        colors.border3
    };

    font-size : 14px;
    font-style : italic;

    color : black;
    font-weight: 500;



    option {

        font-size: 14px;
        font-style: italic;
        color : $ {
            colors.text3
        };
    }

}

.university-category {
    border : 1px solid $ {
        colors.border1
    }

    ;
    padding: 15px 20px 20px;
    border-radius : 5px;
    margin-bottom: 30px;

    h5 {
        color : $ {
            colors.black1
        }

        ;
        font-weight : 600;
        padding-bottom: 10px;
        margin-bottom: 20px;
        position : relative;

        &:before {
            position: absolute;
            content: "";

            background : $ {
                colors.green
            }

            ;
            width : 50px;
            height: 2px;
            bottom : 0;
            left : 0;
        }

        @media(max-width: 575px) {
            font-size: 17px;
        }
    }
}

.search-btn {
    .btn{
        padding: 10px 20px;
        font-weight: bold;
        border-radius: 10px;
    }
    .btn:hover: {
        color: white;
        box-shadow: 0px 4px 0px black;
    }
}

.check-btn {
    // flex: 1 0 21%;
    margin-right: 1%
}

.category-item1 {
    display: flex;
    flexWrap: wrap;
    alignItems: center;
}



.list-items {
    display: flex;
    justify-content: end;
    font-weight: bold;
    margin-bottom: 10px;
    fontsize: 20px 

    .check-btn {
        width: 100px;
        border: none;
        position: relative;
        margin: 0 5px;
        background: #daa402;
        padding: 5px 15px;
        filter: drop-shadow(4px 4px 4px hsl(0 0% 0% / .5));
        color: white;
        border-radius: 20px;
        cursor: pointer;
    }

    .check-btn:hover {
        background: #415c5d;
        color: #fff;
        transition: .5s;
    }

    
}

 @media (max-width: 700px) {
         .list-items {
            display: block;

            .check-btn {
                margin: 10px 0;
            }
            
        }
}

li:hover {
    background-color: #415c5d;
    color: white !important;
}


`;